import { DollarCircleOutlined, UserOutlined } from '@ant-design/icons';
import { Badge, Menu } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ReactComponent as Chat } from '../../images/chat.svg';
import { ReactComponent as Group } from '../../images/group.svg';
import { ReactComponent as Storage } from '../../images/sclad_icon.svg';
import { ReactComponent as Wifi } from '../../images/wifi-lock.svg';

const ItemWrapper = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 79px;
    img,
    .anticon {
      margin-bottom: 10px;
      margin-right: 0px;
    }
    .anticon {
      font-size: 17px;
    }
    span {
      display: flex;
      height: 16px;
      align-items: center;
    }
  }
`;

const MenuItem = styled(Menu.Item)`
  &&& {
    border-bottom-width: 1px;
    border-bottom-color: white;
    margin-top: -9px;
    top: 0px !important;
    &:hover {
      span {
        color: #4b97e9;
      }
      background: #f5faff;
      border-bottom-width: 1px;
      border-bottom-color: #4b97e9;
      svg {
        path {
          fill: #4b97e9;
        }
        &.chat,
        &.group {
          path {
            stroke: #4b97e9;
            fill: white;
          }
        }
      }
      .ant-badge-count {
        .current {
          color: white;
        }
      }
    }
    .ant-badge-count {
      right: 10px;
      margin-top: 17px;
      height: 16px;
      .current {
        margin-top: -1px;
      }
    }
    .ant-menu-horizontal {
       {
        .ant-menu-item {
          top: 0;
        }
      }
    }
    &.active {
      .ant-badge-count {
        .current {
          color: white;
        }
      }
      span {
        color: #4b97e9;
      }
      background: #f5faff;
      border-bottom-width: 1px;
      border-bottom-color: #4b97e9;
      svg {
        path {
          fill: #4b97e9;
        }
        &.chat,
        &.group {
          path {
            stroke: #4b97e9;
            fill: white;
          }
        }
      }
    }
  }
`;

function MainMenu({ message, counts }) {
  const { t } = useTranslation();

  return (
    <Menu mode="horizontal">
      <MenuItem
        className={
          window.location.href.indexOf('storages') > 1 ? `active` : null
        }
        key="storage"
      >
        <ItemWrapper>
          <Link
            className="flex items-center justify-center flex-col"
            to="/storages"
          >
            <Storage className="mb-11" />
            <span className="text-graytext">{t('storages')}</span>
          </Link>
        </ItemWrapper>
      </MenuItem>
      <MenuItem
        className={
          window.location.href.indexOf('customers') > 1 ? `active` : null
        }
        key="user"
      >
        <ItemWrapper>
          <Link
            className="flex items-center justify-center flex-col"
            to="/customers"
          >
            <UserOutlined />
            <span className="mt-3 text-graytext">{t('customers')}</span>
          </Link>
        </ItemWrapper>
      </MenuItem>
      <MenuItem
        className={
          window.location.href.indexOf('devices') > 1 ? `active` : null
        }
        key="wifi"
      >
        <Badge count={counts ? counts.devices : null}>
          <ItemWrapper>
            <Link
              className="flex items-center justify-center flex-col"
              to="/devices"
            >
              <Wifi className="mb-11" />
              <span className="text-graytext">{t('devices')}</span>
            </Link>
          </ItemWrapper>
        </Badge>
      </MenuItem>
      <MenuItem
        className={
          window.location.href.indexOf('transactions') > 1 ? `active` : null
        }
        key="transaction"
      >
        <ItemWrapper>
          <Link
            className="flex items-center justify-center flex-col"
            to="/transactions"
          >
            <DollarCircleOutlined />
            <span className="text-graytext">{t('transactions')}</span>
          </Link>
        </ItemWrapper>
      </MenuItem>
      <MenuItem
        className={window.location.href.indexOf('chat') > 1 ? `active` : null}
        key="chat"
      >
        <Badge count={message > 0 && message !== 0 ? message : null}>
          <ItemWrapper>
            <Link
              className="flex items-center justify-center flex-col"
              to="/chat"
            >
              <Chat className="mb-11 chat" />
              <span className="text-graytext">{t('chat')}</span>
            </Link>
          </ItemWrapper>
        </Badge>
      </MenuItem>
      <MenuItem
        className={
          window.location.href.indexOf('managers') > 1 ? `active` : null
        }
        key="group"
      >
        <ItemWrapper>
          <Link
            className="flex items-center justify-center flex-col"
            to="/managers"
          >
            <Group className="group mb-11" />
            <span className="text-graytext">{t('staff')}</span>
          </Link>
        </ItemWrapper>
      </MenuItem>
      <MenuItem
        className={
          window.location.href.indexOf('pairings') > 1 ? `active` : null
        }
        key="userPair"
      >
        <ItemWrapper>
          <Link
            className="flex items-center justify-center flex-col"
            to="/userPairing"
          >
            <Group className="group mb-11" />
            <span className="text-graytext">{t('User Pairings')}</span>
          </Link>
        </ItemWrapper>
      </MenuItem>
    </Menu>
  );
}

MainMenu.propTypes = {};

export default MainMenu;
